export default "__VITE_ASSET__CaSH8qfq__"